<template>
  <div id="selfStudy_list">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <banner v-bind:pageTypeId="pageTypeId"></banner>
    <!-- banner end -->
    <div class="screen">
      <div class="clearfix screen_1">
        <strong>·FILTERS</strong>
        <span class="icon_open" @click="iconOpen" v-if="screenup">展开</span>
        <span class="icon_shrink" @click="iconShrink" v-else>收起</span>
      </div>
      <div class="clearfix screen_2" :class="{ up: screenup }">
        <div class="tab_boxs" ref="addAlert">
          <p>
            <strong>标签分类：</strong>
            <span>
              <a :class="{ side: bqflNumber == 0 }" @click="bqfl(0)">不限</a>
              <a :class="{ side: bqflNumber == 1 }" @click="bqfl(1)"
                >备考辅助</a
              >
              <a :class="{ side: bqflNumber == 2 }" @click="bqfl(2)"
                >小白学院</a
              >
            </span>
          </p>
          <p style="margin-left: 72px;">
            <span>
              <a
                :class="{ side: nameIndex == index }"
                @click="flclick(index)"
                v-for="(item, index) in bkfzList"
                >{{ item.Name }}
              </a>
            </span>
          </p>
        </div>
        <p>
          <strong>课程分类：</strong>
          <span>
            <a :class="{ side: kcflNum == 0 }" @click="kcflClick(0)">不限</a>
            <a
              :class="{ side: kcflNum == index + 1 }"
              @click="kcflClick(index + 1)"
              v-for="(item, index) in kcflList"
              >{{ item.Name }}</a
            >
          </span>
        </p>
        <p v-if="CourseC1">
          <strong>科目分类：</strong>
          <span>
            <a :class="{ side: kmNum == 0 }" @click="kmClick(0)">不限</a>
            <a
              :class="{ side: kmNum == index + 1 }"
              @click="kmClick(index + 1)"
              v-for="(item, index) in kmList"
              >{{ item }}</a
            >
          </span>
        </p>
        <p v-if="CourseC2">
          <strong>科目标签：</strong>
          <span>
            <a :class="{ side: tagsNum == 0 }" @click="SubjectsClick(0)"
              >不限</a
            >
            <a
              v-show="kmNum != 0"
              :class="{ side: tagsNum == index + 1 }"
              @click="SubjectsClick(index + 1)"
              v-for="(item, index) in SubjectsTags"
              >{{ item.Name }}</a
            >
          </span>
        </p>
      </div>
      <div class="clearfix screen_3">
        <strong>排序方式：</strong>
        <a :class="{ side: pxID == 1 }" @click="SortMode(0)">最新发布</a>
        <a :class="{ side: pxID == 2 }" @click="SortMode(1)">阅读量</a>
        <span>共{{ total }}条内容</span>
      </div>
      <div class="clearfix screen_S">
        <input
          type="text"
          placeholder="输入关键词以搜索内容"
          v-model="searchValue"
          @keyup.enter="searchEnter"
          @focus="searchfocus(1)"
          @blur="searchblur(2)"
        />
        <button class="search_btn" type="primary" @click="searchClick">
          搜索
        </button>
      </div>
    </div>
    <!-- screen end -->
    <div class="main">
      <div class="main_list">
        <ul class="clearfix">
          <li v-for="(item, index) in bigList" @click="listDetails(index)">
            <!-- <router-link v-for="item,index in bigList" :key="item.id" :to="{path:'/selfStudy_details',query: {'KId': item.Id,'nav':2}}" tag="li" @click="changNumber(index)"> -->
            <dl class="clearfix">
              <dt><img :src="item.CoverImg" /></dt>
              <dd>
                <h2>{{ item.Title }}</h2>
                <p class="p1">摘要：{{ item.Abstract }}</p>
                <p class="p2">
                  #{{ item.ApplyStudentName.replace(/,/g, "#") }}
                </p>
                <p class="p3">
                  <span>{{ item.AddTime }}</span
                  ><span>阅读量{{ item.PageView }}</span>
                </p>
              </dd>
            </dl>
            <!-- </router-link> -->
          </li>
        </ul>
        <!-- main_list end -->
        <div class="block" style="text-align: right;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            :total="total"
            background
            layout="total,prev, pager, next, jumper,->"
          >
          </el-pagination>
        </div>
        <!-- block end -->
      </div>

      <!-- main_list end -->
      <div class="main_bottom" v-if="zsyc">
        <!-- main_bottom end -->
        <div class="title">
          <span><em></em><strong>热门公开课</strong></span>
        </div>
        <div class="mani_list">
          <ul class="clearfix">
            <li v-for="(items, index) in publicClass" :key="items.id">
              <!-- <a :href="items.JumpUrl"> -->
              <router-link
                :to="{
                  path: '/publicClass_details',
                  query: { KId: items.JumpUrl, nav: 3 }
                }"
              >
                <!-- <router-link :to="{path:'items.JumpUrl'}"> -->
                <dl>
                  <dt>
                    <img :src="publicClass_imgs[index][0]" width="100%" />
                  </dt>
                  <dd>
                    <h2>{{ items.Title }}</h2>
                    <p class="p1">
                      #{{ publicClass_p[index].student.replace(/,/g, "#") }}
                    </p>
                    <p class="p2">{{ publicClass_p[index].time }}</p>
                    <div class="p3">
                      <em
                        ><img :src="publicClass_imgs[index][1]" width="100%"
                      /></em>
                      <span>{{ publicClass_p[index].teacher }}</span>
                      <strong>{{ publicClass_p[index].price }}</strong>
                    </div>
                  </dd>
                </dl>
              </router-link>
              <!-- </a> -->
            </li>
          </ul>
        </div>
      </div>
      <!-- main_bottom end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

import banner from "../../page2/banner/banner.vue"; //头部banner图
export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
    banner
  },
  metaInfo() {
    return {
      title: "自学备考专区",
      meta: [
        {
          name: "keywords",
          content:
            "自学备考专区,雅思自学备考,雅思备考攻略,托福自学备考,托福备考攻略"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      tokenkey: "",
      pageTypeId: 18,
      screenup: false,
      publicClass: "", //广告循环
      // typelist: '',
      currentPage: 1, // 当前页码
      total: 10, // 总条数
      pageSize: 10, // 每页的数据条数
      // maniList: '',
      enumList: "",
      bkfzList: [], //备考辅助
      bqflNumber: 0, //标签分类class
      bigList: [], //列表数组
      nameIndex: -1, //标签分类下的class
      kcflList: [], //课程分类列表
      kcflNum: "", //课程分类class
      CourseC1: false,
      CourseC2: false,
      kcflIds: 0, //课程分类ID
      kmList: [], //科目列表
      kmNum: "", //科目class
      kmId: "", //科目ID
      SubjectsTags: [], //科目标签列表
      tagsNum: 0, //科目标签列表class
      Ids: 0, //标签分类下的选项Id
      kmflId: 0, //科目分类ID
      bqId: 0,
      pxID: 1,
      bkfzIdList: [], //备考辅助ID集合
      goPage: "",
      searchValue: "", //搜索至
      zsyc: false //暂时隐藏
    };
  },
  // watch: {
  //   pageNumber: function(){
  //     this.bigList.forEach(function(item){
  //       item.PageView
  //     })

  //   }

  // },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    // 枚举
    //默认筛选分类
    that.tokenkey = that.$cookies.get("token");
    let enums = sessionStorage.getItem("enum");
    // this.kcflList = JSON.parse(enums)[0].List
    var KcEnums = JSON.parse(enums);
    // // console.log(KcEnums)
    KcEnums.filter(item => {
      if (item.Code === "CourseType") {
        this.kcflList = item.List;
      }
    });

    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=6")
      .then(function(response) {
        that.publicClass = response.data.results.slice(0, 4);
        var bobao = [];
        var imgs = [];
        for (var i = 0; i < response.data.results.length; i++) {
          var bobao_xq = JSON.parse(response.data.results[i].MoreFieldsValue);
          var imgs_xq = response.data.results[i].ImageArrays.split(",");
          bobao.push(bobao_xq);
          imgs.push(imgs_xq);
        }
        that.publicClass_p = bobao;
        that.publicClass_imgs = imgs;
        // // console.log(bobao)
        // // console.log(imgs)
      })
      .catch(function() {
        // console.log('错误');
      });
    //默认显示全部列表
    that.publicFuntion(
      that.currentPage,
      that.bqflNumber,
      that.Ids,
      that.kcflIds,
      that.kmflId,
      that.bqId,
      that.pxID,
      that.searchValue
    );
    var typelist = this.$route.query.typelist;
    if (typelist == 2) {
      this.typelist = false;
    } else {
      this.typelist = true;
    }
    // 从详情页-分类链接，点击后处理
    let detailsClick = parseFloat(that.$route.params.flag);
    //const detailsClick = 1
    // // console.log(detailsClick==1)

    switch (detailsClick) {
      case 1:
        that.bqflNumber = 1;
        that.nameIndex = 1;
        that.bqfl(1);
        that.flclick(0);
        break;
      case 2:
        that.bqflNumber = 1;
        that.nameIndex = 1;
        that.bqfl(1);
        that.flclick(1);
        break;
      case 3:
        that.bqflNumber = 1;
        that.nameIndex = 1;
        that.bqfl(1);
        that.flclick(2);
        break;
      // 小白
      case 4:
        that.bqfl(2);
        // 入门常识
        that.Ids = 39;
        that.nameIndex = 3;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
      case 5:
        that.bqfl(2);
        // 报考相关
        that.Ids = 40;
        that.nameIndex = 4;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
      case 6:
        that.bqfl(2);
        that.Ids = 41;
        that.nameIndex = 5;

        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
      case 7:
        that.bqfl(2);
        that.Ids = 42;
        that.nameIndex = 0;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
      case 8:
        that.bqfl(2);
        that.Ids = 43;
        that.nameIndex = 1;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
      case 9:
        that.bqfl(2);
        that.Ids = 44;
        that.nameIndex = 2;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?type=" +
              that.bqflNumber +
              "&lableType=" +
              that.Ids +
              "&courseType=0&subjectType=0&subjectLable=0&orderType=0"
          )
          .then(function(responses) {
            that.bigList = responses.data.results;
            that.total = responses.data.count; //列表的总个数
          })
          .catch(function() {
            // console.log('数据错误');
          });
        break;
    }
  },
  methods: {
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    handleCurrentChange(val) {
      let that = this;
      //// console.log(`当前页: ${val}`);
      that.currentPage = val;
      that.publicFuntion(
        that.currentPage,
        that.bqflNumber,
        that.Ids,
        that.kcflIds,
        that.kmflId,
        that.bqId,
        that.pxID,
        that.searchValue
      );
    },
    // 标签分类点击事件
    bqfl(numIndex) {
      let that = this;
      //----
      this.kcflNum = 0;
      this.kmNum = 0;
      this.tagsNum = 0;
      this.kmList = [];
      //---
      this.nameIndex = -1; //点击标签分类后--子标签默认不被选中
      this.bqflNumber = numIndex;
      //// console.log(numIndex)
      that.CourseC1 = false;
      that.CourseC2 = false;
      if (numIndex == 0) {
        //点击不限
        this.$refs.addAlert.style.height = "51px";
        this.currentPage = 1; //重置分页
        this.tagsNum = 0; //科目标签列表class
        this.Ids = 0; //标签分类下的选项Id
        this.kmflId = 0; //科目分类ID
        this.bqId = 0;
        this.kcflIds = 0; //课程分类
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      } else if (numIndex == 1) {
        //点击备考专区
        this.$refs.addAlert.style.height = "102px";
        this.currentPage = 1; //重置分页
        this.Ids = 0; //标签分类下的选项Id
        this.kmflId = 0; //科目分类ID
        this.bqId = 0;
        this.kcflIds = 0; //课程分类
        // 请求备考专区下的子集
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/Enum?nameCode=TestDataLabel"
          )
          .then(function(response) {
            that.bkfzList = response.data.results;
            //// console.log(that.bkfzList)
            that.publicFuntion(
              that.currentPage,
              that.bqflNumber,
              that.Ids,
              that.kcflIds,
              that.kmflId,
              that.bqId,
              that.pxID,
              that.searchValue
            );
          })
          .catch(function() {
            // console.log('数据错误');
          });
      } else {
        //点击小白学院noneBox
        this.$refs.addAlert.style.height = "102px";
        this.currentPage = 1; //重置分页
        this.Ids = 0; //标签分类下的选项Id
        this.kmflId = 0; //科目分类ID
        this.bqId = 0;
        this.kcflIds = 0; //课程分类
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/Enum?nameCode=NewCollegeLabel"
          )
          .then(function(response) {
            that.bkfzList = response.data.results;
            that.publicFuntion(
              that.currentPage,
              that.bqflNumber,
              that.Ids,
              that.kcflIds,
              that.kmflId,
              that.bqId,
              that.pxID,
              that.searchValue
            );
          })
          .catch(function() {
            // console.log('数据错误');
          });
      }
    },
    publicFuntion(
      page,
      type,
      lableType,
      courseType,
      subjectType,
      subjectLable,
      orderType,
      keyword
    ) {
      let that = this;
      // console.log(page, type, lableType, courseType, subjectType, subjectLable, orderType, keyword)
      that.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam?page=" +
            page +
            "&limit=10&type=" +
            type +
            "&lableType=" +
            lableType +
            "&courseType=" +
            courseType +
            "&subjectType=" +
            subjectType +
            "&subjectLable=" +
            subjectLable +
            "&orderType=" +
            orderType +
            "&keyword=" +
            keyword
        )
        .then(function(responses) {
          // // console.log(responses)
          that.bigList = responses.data.results;
          that.total = responses.data.count; //列表的总个数
        })
        .catch(function() {
          // console.log('数据错误');
        });
    },
    // getlivestockInfo(val) {
    //   let that = this
    //   that.publicFuntion(that.currentPage, that.bqflNumber, that.Ids, that.kcflIds, that.kmflId, that.bqId, that
    //     .pxID, that.searchValue)
    // },
    //标签分类下的点击分类
    flclick(indexNum) {
      let that = this;
      //----
      this.kcflNum = 0;
      this.kmNum = 0;
      this.tagsNum = 0;
      this.kmList = [];
      //----
      this.currentPage = 1; //重置分页
      this.Ids = 0; //标签分类下的选项Id
      this.kmflId = 0; //科目分类ID
      this.bqId = 0;
      this.kcflIds = 0; //课程分类
      this.nameIndex = indexNum;
      // 点击备考辅助下的切换
      if (this.bqflNumber == 1) {
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/Enum?nameCode=TestDataLabel"
          )
          .then(function(response) {
            that.Ids = response.data.results[indexNum].Id;

            that.publicFuntion(
              that.currentPage,
              that.bqflNumber,
              that.Ids,
              that.kcflIds,
              that.kmflId,
              that.bqId,
              that.pxID,
              that.searchValue
            );
          })
          .catch(function() {
            // console.log('数据错误');
          });
      } else if (this.bqflNumber == 2) {
        // 点击小白学院下的切换
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/Enum?nameCode=NewCollegeLabel"
          )
          .then(function(response) {
            that.Ids = response.data.results[indexNum].Id;
            // // console.log(that.Ids)
            that.publicFuntion(
              that.currentPage,
              that.bqflNumber,
              that.Ids,
              that.kcflIds,
              that.kmflId,
              that.bqId,
              that.pxID,
              that.searchValue
            );
          })
          .catch(function() {
            // console.log('数据错误');
          });
      }
    },
    //课程分类
    kcflClick(curNum) {
      let that = this;
      this.kmNum = 0; //点击课程科目默认等于不限
      this.kcflNum = curNum;
      this.kmList = [];
      //// console.log(curNum)
      that.kmflId = 0;
      this.tagsNum = 0;
      this.currentPage = 1; //重置分页

      //点击科目
      if (curNum > 0) {
        that.CourseC1 = true;
        let objName = this.kcflList[curNum - 1].List;
        let numbers = [];
        let kmId = [];
        objName.filter(item => {
          if (item.Type === 2) {
            numbers.push(item.Name);
            kmId.push(item.Id);
          }
        });
        this.kmList = numbers;
        this.kmIds = kmId; //科目ID
        this.kcflIds = this.kcflList[curNum - 1].Id; //课程分类ID

        that.kmflId = 0;
        that.bqId = 0;
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      } else {
        //点击课程分类里的（不限）
        that.kcflIds = 0;
        that.CourseC1 = false;
        this.kmList = [];
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      }
    },
    // 科目分类
    kmClick(kmClassNum) {
      let that = this;
      this.tagsNum = 0; //点击课程科目默认等于不限
      this.kmNum = kmClassNum;
      this.SubjectsTags = [];
      this.currentPage = 1; //重置分页
      if (kmClassNum > 0) {
        that.CourseC2 = true;
        that.bqId = 0;
        let objName = this.kcflList[this.kcflNum - 1].List;
        let numbers = [];
        objName.filter(item => {
          if (item.Type === 2) {
            // // console.log(item)
            numbers.push(item);
          }
        });
        this.SubjectsTags = numbers[kmClassNum - 1].List;
        this.kmflId = numbers[kmClassNum - 1].Id; //科目分类Id
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      } else {
        that.CourseC2 = false;
        this.kmflId = 0;
        // that.bqId = 0//科目标签
        that.bqId = 0;
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      }
    },
    // 科目标签
    SubjectsClick(a) {
      let that = this;
      this.tagsNum = a;
      this.currentPage = 1; //重置分页
      if (a > 0) {
        that.bqId = that.SubjectsTags[this.tagsNum - 1].Id;
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      } else {
        //不限
        that.bqId = 0;
        that.publicFuntion(
          that.currentPage,
          that.bqflNumber,
          that.Ids,
          that.kcflIds,
          that.kmflId,
          that.bqId,
          that.pxID,
          that.searchValue
        );
      }
    },
    //排序方式
    SortMode(b) {
      let that = this;
      this.pxID = b + 1;
      this.currentPage = 1; //重置分页
      that.publicFuntion(
        that.currentPage,
        that.bqflNumber,
        that.Ids,
        that.kcflIds,
        that.kmflId,
        that.bqId,
        that.pxID,
        that.searchValue
      );
    },

    // 搜索
    searchClick() {
      let that = this;
      this.currentPage = 1; //重置分页
      that.publicFuntion(
        that.currentPage,
        that.bqflNumber,
        that.Ids,
        that.kcflIds,
        that.kmflId,
        that.bqId,
        that.pxID,
        that.searchValue
      );
    },
    searchfocus(e) {
      this.enter = e;
    },
    searchblur(e) {
      this.enter = e;
    },
    searchEnter() {
      document.onkeydown = e => {
        //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
        if (e.keyCode === 13 && this.enter == 1) {
          //回车后执行搜索方法
          this.searchClick();
        }
      };
    },
    listDetails(cur) {
      let that = this;
      var targetUser = this.bigList[cur].Id;
      let goPage = 0;
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/History",
          {
            ContentType: 49,
            ContentId: targetUser,
            WatchTime: goPage
          },
          {
            headers: {
              ContentType: "application/json",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // 添加阅读量成功后跳转
          that.$router.push({
            name: "selfStudy_details",
            query: {
              KId: targetUser,
              page: that.currentPage,
              nav: 2
            }
          });
        })
        .catch(function(error) {
          // console.log(error);
        });
    }
  },
  // 离开页面时提交时间
  beforeDestroy: function() {
    let that = this;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab_boxs {
  overflow: hidden;
  transition: 0.2s;
  height: 51px;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.header_left {
  background: #f00;
}

.banner {
  width: 100%;
  height: 452px;
  position: relative;
  overflow: hidden;
}

.banner img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -960px;
}

.screen {
  background: #fff;
}

.screen_1 {
  width: 1180px;
  height: 66px;
  border-bottom: 1px #d5d5d5 solid;
  padding-top: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 20px;
}

.screen_1 strong {
  display: block;
  font-size: 16px;
  color: #d5d5d5;
  line-height: 20px;
  float: left;
  font-weight: normal;
}

.screen_1 span {
  display: block;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  float: right;
  padding-right: 14px;
  background: url(../../assets/publicClass/icon_shrink.png) right no-repeat;
  cursor: pointer;
}

.screen_1 .icon_open {
  background: url(../../assets/publicClass/icon_open.png) right no-repeat;
}

.screen_2 {
  width: 1180px;
  margin: 0 auto;
  box-sizing: border-box;
  border-bottom: 1px #d5d5d5 solid;
  margin-bottom: 20px;
}

.screen_2.up {
  display: none;
}

.screen_2 p {
  margin-bottom: 15px;
  text-align: left;
  display: table;
  height: 36px;
}

.screen_2 p strong {
  display: inline-block;
  width: 75px;
  font-size: 14px;
  line-height: 36px;
  height: 36px;
  color: #999;
  /* margin-right: 24px; */
  float: left;
}

.screen_2 p span {
  display: inline-block;
  width: 1080px;
  float: left;
}

.screen_2 p a {
  display: inline-block;
  min-width: 75px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 10px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.screen_2 p a:hover {
  color: #4e5cf6;
}

.screen_2 p a.side {
  background: #f8f8f8;
  color: #4e5cf6;
}

.screen_3 {
  width: 1180px;
  padding-bottom: 20px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
}

.screen_3 strong {
  display: inline-block;
  font-size: 14px;
  line-height: 36px;
  color: #999;
  margin-right: 24px;
}

.screen_3 a {
  display: inline-block;
  width: 82px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 10px;
  color: #333333;
  text-align: center;
  cursor: pointer;
}

.screen_3 a.side {
  background: #f8f8f8;
  color: #4e5cf6;
}

.screen_3 span {
  float: right;
  font-size: 14px;
  color: #333;
  line-height: 36px;
}

.main {
  width: 100%;
  background: #fafafa;
  padding-top: 30px;
  padding-bottom: 100px;
}

.main_list {
  width: 1180px;
  margin: 0 auto;
}

.main_list ul {
  margin-bottom: 12px;
}

.main_list ul li {
  width: 580px;
  height: 140px;
  background: #ffffff;
  border-radius: 8px;
  float: left;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main_list ul li:nth-child(2n) {
  margin-right: 0;
}

.main_list ul li:hover {
  box-shadow: 0px 0px 6px 6px #f2f2f2;
  transform: translateY(-4px);
}

.main_list ul li dl {
  padding-top: 18px;
  padding-right: 12px;
}

.main_list ul li dl dt {
  width: 166px;
  height: 103px;
  overflow: hidden;
  float: right;
}

.main_list ul li dl dt img {
  width: 166px;
  height: 103px;
}

.main_list ul li dl dd {
  width: 364px;
  float: left;
  padding-left: 20px;
  text-align: left;
}

.main_list ul li dl dd h2 {
  width: 100%;
  height: 26px;
  font-size: 16px;
  line-height: 26px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
  margin-bottom: 2px;
}

.main_list ul li dl dd .p1 {
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #333333;
  margin-bottom: 2px;
}

.main_list ul li dl dd .p2 {
  font-size: 14px;
  line-height: 26px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
  margin-bottom: 2px;
}

.main_list ul li dl dd .p3 {
  color: #666;
}

.main_list ul li dl dd .p3 span {
  display: inline-block;
  width: 148px;
  line-height: 18px;
  font-size: 12px;
}

.list_mores {
  width: 160px;
  height: 36px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #999999;
  font-size: 16px;
  text-align: center;
  line-height: 36px;
  color: #999;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.list_mores:hover {
  border: 1px solid #666;
  color: #666;
}

.main_bottom {
  width: 1180px;
  margin: 0 auto;
  padding-top: 66px;
}

.main_bottom .title {
  height: 77px;
  text-align: center;
}

.main_bottom .title span {
  display: inline-block;
  font-size: 28px;
  color: #333333;
  line-height: 56px;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 13px;
  background: url(../../assets/publicClass/main_bottom2.png) right 34px
    no-repeat;
  position: relative;
}

.main_bottom .title span em {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
}

.main_bottom .title span strong {
  position: relative;
  font-weight: normal;
}

.mani_list ul li {
  width: 280px;
  height: 346px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.mani_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  transform: translateY(-8px);
}

.mani_list ul li:nth-child(4n) {
  margin-right: 0;
}

.mani_list ul li dt {
  width: 280px;
  overflow: hidden;
}

.mani_list ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.mani_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 20px;
  height: 40px;
  margin-bottom: 8px;
  font-weight: normal;
}

.mani_list ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #ff9d00;
  line-height: 12px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mani_list ul li dd .p2 {
  font-size: 12px;
  color: #666;
  line-height: 12px;
  margin-bottom: 24px;
}

.mani_list ul li dd .p3 {
  height: 38px;
}

.mani_list ul li dd .p3 em {
  display: block;
  width: 34px;
  height: 34px;
  border: 2px #f5f6f6 solid;
  border-radius: 38px;
  float: left;
  overflow: hidden;
  margin-right: 8px;
}

.mani_list ul li dd .p3 span {
  font-size: 14px;
  color: #333;
  line-height: 38px;
}

.mani_list ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}

.screen_S {
  width: 1180px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 40px;
}

.screen_S input {
  width: 250px;
  height: 36px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding: 0 15px;
}

.screen_S .search_btn {
  position: absolute;
  top: 1px;
  left: 245px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border: none;
  background: url(../../assets/personal/icon_search_Default.png) no-repeat;
  overflow: hidden;
  text-indent: -999px;
}
</style>



// WEBPACK FOOTER //
// src/page2/selfStudy/selfStudy_list.vue